import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InlineSvgFragment } from './inline-svg/inline-svg.fragment';
import { CardsFragment } from './cards/cards.fragment';
import { AgendaEventFragment } from './agenda-event/agenda-event.fragment';
import { ButtonFragment } from './button/button.fragment';
import { SearchInputFragment } from './search-input/search-input.fragment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormInputFragment } from './form-input/form-input.fragment';
import { TableFragment } from './table/table.fragment';
import { NgxPaginationModule } from 'ngx-pagination';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { SideMenuFragment } from './side-menu/side-menu-fragment/side-menu.fragment';
import { SideMenuContainerFragment } from './side-menu/side-menu-container/side-menu-container.fragment';
import { LoadingModalFragment } from './modal/loading/loading-modal.fragment';
import { TableRadioButtonFragment } from './table-radio-button/table-radio-button.fragment';
import { AlertMessageFragment } from './modal/alert-message/alert-message.fragment';
import { AddEditFragment } from './modal/add-edit/add-edit.fragment';
import { ConfirmationMessageFragment } from './modal/confirmation-message/confirmation-message.fragment';
import { InsQualificationFragment } from './modal/ins-qualification/ins-qualification.fragment';
import { CardNoScrollFragment } from './card-no-scroll/card-no-scroll.fragment';
import { MemoFragment } from './modal/memo/memo.fragment';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatMenuModule } from '@angular/material/menu';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AddPatientFragment } from './modal/add-patient/add-patient.fragment';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ChipFragment } from './chip/chip.fragment';
import { MultipleChoiceFragment } from './modal/multiple-choice/multiple-choice.fragment';
import { HeaderFragment } from './header/header.fragment';
import { AlarmeFragment } from './modal/alarme/alarme.fragment';
import { HistoProfessionFragment } from './modal/histo-profession/histo-profession.fragment';
import { HistoContactFragment } from './modal/histo-contact/histo-contact.fragment';
import { HistoRepertoireFragment } from './modal/histo-repertoire/histo-repertoire.fragment';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ParentPatientFragment } from './modal/parent-patient/parent-patient.fragment';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDividerModule } from '@angular/material/divider';
import { AideSaisieFragment } from './modal/aide-saisie/aide-saisie.fragment';
import { InputMaskModule } from 'racoon-mask-raw';
import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { ImportDocumentsComponent } from './import-documents/import-documents.component';
import { ModalCreateConsultationComponent } from './import-documents/modal-create-consultation/modal-create-consultation.component';
import { ModalConflictComponent } from './import-documents/modal-conflict/modal-conflict.component';
import { ListAddDocumentsComponent } from './list-add-documents/list-add-documents.component';
import { DisplayDocumentComponent } from './display-document/display-document.component';
import { GEDViewerComponent } from './display-document/gedviewer/gedviewer.component';
import { GEDImageViewerComponent } from './display-document/gedimage-viewer/gedimage-viewer.component';
import { RechercheMultiListeFragment } from './modal/recherche-multi-liste/recherche-multi-liste.fragment';
import { RechercheMultiSaveFragment } from './modal/recherche-multi-save/recherche-multi-save.fragment';
import { ReferentielNewFragment } from './modal/referentiel-new/referentiel-new.fragment';
import { SaisieGuideeFragment } from './modal/saisie-guidee/saisie-guidee.fragment';
import { SearchCritereFragment } from './modal/search-critere/search-critere.fragment';
import { GoogleChartsModule } from 'angular-google-charts';
import { ConsultDataFragment } from './modal/consult-data/consult-data.fragment';
import { GroupementNewFragment } from './modal/groupement-new/groupement-new.fragment';
import { EditCourrierFragment } from './modal/edit-courrier/edit-courrier.fragment';
import { QuillModule } from 'ngx-quill';
import { AddCorrespondantCourrier } from './modal/add-correspondant-courrier/add-correspondant-courrier.fragment';
import { AddCorrespondantInEditorComponent } from './modal/add-correspondant-in-editor/add-correspondant-in-editor.component';
import { SelectConsultationFragment } from './modal/select-consultation/select-consultation.fragment';
import { GEDPdfViewerComponent } from './display-document/gedpdf-viewer/gedpdf-viewer.component';
import { FroalaContentViewerComponent} from './display-document/froala-content-viewer/froala-content-viewer.component';
import { CourrierContentViewerComponent } from './display-document/courrier-content-viewer/courrier-content-viewer.component';
import { AddCourrierPersoFragment } from './modal/add-courrier-perso/add-courrier-perso.fragment';
import { SelectListFragment } from './modal/select-list/select-list.fragment';
import { SearchPatientComponent } from './dmp/search-patient/search-patient.component';
import { DmpAccessRequestModalComponent } from './dmp/dmp-access-request-modal/dmp-access-request-modal.component';
import { DisplayDmpComponent } from './dmp/display-dmp/display-dmp.component';
import { AddDocumentsComponent } from './dmp/add-documents/add-documents.component';
import { HandleCpxModalComponent } from './modal/handle-cpx-modal/handle-cpx-modal.component';
import { SelectSlotComponent } from './modal/handle-cpx-modal/select-slot/select-slot.component';
import { SelectPracticeLocationComponent } from './modal/handle-cpx-modal/select-practice-location/select-practice-location.component';
import { DmpComponent } from './dmp/dmp.component';
import { InsiFragment } from './modal/insi/insi.fragment';
import { RechercheBddMedFragment } from './modal/recherche-bdd-med/recherche-bdd-med.fragment';
import { CcamFragment } from './modal/ccam/ccam.fragment';
import { ModificateurFragment } from './modal/modificateur/modificateur.fragment';
import { HonorairesFragment } from './modal/honoraires/honoraires.fragment';
import { SearchPatientsFragment } from './modal/search-patients/search-patients.fragment';
import { HtmlErrorComponent } from './html-error/html-error.component';
import { SearchCim10Fragment } from './modal/search-cim10/search-cim10.fragment';
import { AddProductFragment } from './modal/add-product/add-product.fragment';
import { EditOrdonnanceFragment } from './modal/edit-ordonnance/edit-ordonnance.fragment';
import { FicheSamFragment } from './modal/fiche-sam/fiche-sam.fragment';
import { DocumentFormComponent } from './modal/document-form/document-form.component';
import { ProgressFragment } from './modal/progress/progress.fragment';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCardModule } from '@angular/material/card';
import { CreatePatientExistsFragment } from './modal/create-patient-exists/create-patient-exists.fragment';
import { QuickSendMSSFragment } from './modal/quick-send-mss/quick-send-mss.fragment';
import { DirectivesModule } from '../directives/directives.module';
import { HistoriquePatientComponent } from './modal/historique-patient/historique-patient.component';
import { RechercheReferentielComponent } from './modal/recherche-referentiel/recherche-referentiel.component';
import { CreatePatientFromCdaComponent } from './modal/create-patient-from-cda/create-patient-from-cda.component';
import { InfoCorrespondantFragment } from './modal/info-correspondant/info-correspondant.fragment';
import { DatamatrixReaderComponent } from './datamatrix-reader/datamatrix-reader.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { MatSelectModule } from '@angular/material/select';
import { ComparePatientInfosComponent } from './modal/compare-patient-infos/compare-patient-infos.component';
import { SearchMedNomFragment } from './modal/search-med-nom/search-med-nom.fragment';
import { ApercuCrbioComponent } from './modal/apercu-crbio/apercu-crbio.component';
import { HandleMssModalComponent } from './modal/handle-mss-modal/handle-mss-modal.component';
import { AddActeFragment } from './modal/add-acte/add-acte.fragment';
import { EnvoiEprescription } from './modal/envoi-eprescription/envoi-eprescription.fragment';
import { RechercheDispositifMedicalComponent } from './modal/recherche-dispositif-medical/recherche-dispositif-medical.component';
import { EnableRemplacement } from './modal/enable-remplacement/enable-remplacement.fragment';
import { DisplayEprescriptionFragment } from './modal/display-eprescription/display-eprescription.fragment';
import { StellairPatientFormComponent } from './modal/stellair-patient-form/stellair-patient-form.component';
import { StellairSelectPatientCvComponent } from './modal/stellair-select-patient-cv/stellair-select-patient-cv.component';
import { MigrationComponent } from './modal/migration/migration.component';
import { HandleCguComponent } from './modal/handle-cgu/handle-cgu.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatRadioModule } from '@angular/material/radio';
import { FusionPassphraseFragment } from '../pages/user/patient/dossier-patient/medical-data-sharing/fusion-passphrase/fusion-passphrase.fragment';
import { FusionConfigFragment } from '../pages/user/patient/dossier-patient/medical-data-sharing/fusion-config/fusion-config.fragment';
import { CpsChoixSituationComponent } from './modal/CPS-choixSituation/cps-choix-situation.component';
import { EdcChoixActiviteComponent } from './modal/edc-choix-activite/edc-choix-activite.component';
import { CvChoixbenefComponent } from './modal/CV-choixBenef/cv-choix-benef.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { ChoixPatientDegradeComponent } from './modal/choix-patient-degrade/choix-patient-degrade.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CalculImcComponent } from './modal/calcul-imc/calcul-imc.component';
import { AnnuaireComponent } from './modal/annuaire/annuaire.component';
import { MatTabsModule } from '@angular/material/tabs';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { EditAdressePatientComponent } from './modal/edit-adresse-patient/edit-adresse-patient.fragment';
import { MatChipsModule } from '@angular/material/chips';
import { AddPaiementFactureComponent } from './modal/add-paiement-facture/add-paiement-facture.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ConfirmationChoixCustomComponent } from './modal/confirmation-choix-custom/confirmation-choix-custom.component';
import { MatOptionModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AddFactureHandComponent } from './modal/add-facture-hand/add-facture-hand.component';
import { CompareImagesModalComponent } from './modal/compare-images-modal/compare-images-modal.component';
import { SelectDocumentModalComponent } from './modal/select-document-modal/select-document-modal.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { AtcdSidePanelFragment } from './atcd-side-panel/atcd-side-panel.fragment';
import { PresaisieMaquettefragment } from './presaisie-maquette/presaisie-maquette.fragment';
import { ConfirmationSelectionMultipleCustomFragment } from './modal/confirmation-selection-multiple-custom/confirmation-selection-multiple-custom.fragment';
import { AddAlarmeComponent } from '../pages/user/patient/dossier-patient/vaccins-alarmes/alarmes/add-alarme/add-alarme.component';
import { ModeleOrdonnancePanelFragment } from './modele-ordonnance-panel/modele-ordonnance-panel.fragment';
import { EnregistrerModeleOrdonnanceFragment } from './modal/enregistrer-modele-ordonnance/enregistrer-modele-ordonnance.fragment';

const MOMENT_FORMATS = {
  parse: {
    dateInput: 'L',
  },
  display: {
    monthYearLabel: 'MMM YYYY',
    dateInput: 'DD/MM/YYYY'
  },
};
@NgModule({
  declarations: [
    AddAlarmeComponent,
    InlineSvgFragment,
    CardsFragment,
    AgendaEventFragment,
    ButtonFragment,
    SearchInputFragment,
    FormInputFragment,
    TableFragment,
    SideMenuFragment,
    SideMenuContainerFragment,
    LoadingModalFragment,
    TableRadioButtonFragment,
    AlertMessageFragment,
    AddEditFragment,
    ConfirmationMessageFragment,
    InsQualificationFragment,
    CardNoScrollFragment,
    MemoFragment,
    AddPatientFragment,
    ChipFragment,
    MultipleChoiceFragment,
    HeaderFragment,
    AlarmeFragment,
    HistoProfessionFragment,
    HistoContactFragment,
    HistoRepertoireFragment,
    ParentPatientFragment,
    AideSaisieFragment,
    ModalCreateConsultationComponent,
    ModalConflictComponent,
    ListAddDocumentsComponent,
    ImportDocumentsComponent,
    DisplayDocumentComponent,
    GEDViewerComponent,
    GEDImageViewerComponent,
    RechercheMultiListeFragment,
    RechercheMultiSaveFragment,
    ReferentielNewFragment,
    SaisieGuideeFragment,
    SearchCritereFragment,
    ConsultDataFragment,
    GroupementNewFragment,
    EditCourrierFragment,
    AddCorrespondantCourrier,
    AddCorrespondantInEditorComponent,
    SelectConsultationFragment,
    GEDPdfViewerComponent,
    FroalaContentViewerComponent,
    SelectListFragment,
    CourrierContentViewerComponent,
    AddCourrierPersoFragment,
    DmpComponent,
    SearchPatientComponent,
    DmpAccessRequestModalComponent,
    DisplayDmpComponent,
    AddDocumentsComponent,
    HandleCpxModalComponent,
    SelectSlotComponent,
    SelectPracticeLocationComponent,
    SelectListFragment,
    InsiFragment,
    SelectListFragment,
    RechercheBddMedFragment,
    CcamFragment,
    ModificateurFragment,
    HonorairesFragment,
    SearchPatientsFragment,
    HtmlErrorComponent,
    SearchCim10Fragment,
    AddProductFragment,
    AddActeFragment,
    EnvoiEprescription,
    EnableRemplacement,
    EditOrdonnanceFragment,
    FicheSamFragment,
    DocumentFormComponent,
    ProgressFragment,
    CreatePatientExistsFragment,
    QuickSendMSSFragment,
    HistoriquePatientComponent,
    RechercheReferentielComponent,
    CreatePatientFromCdaComponent,
    InfoCorrespondantFragment,
    ComparePatientInfosComponent,
    SearchMedNomFragment,
    DatamatrixReaderComponent,
    ApercuCrbioComponent,
    HandleMssModalComponent,
    RechercheDispositifMedicalComponent,
    DisplayEprescriptionFragment,
    StellairPatientFormComponent,
    StellairSelectPatientCvComponent,
    MigrationComponent,
    HandleCguComponent,
    FusionPassphraseFragment,
    FusionConfigFragment,
    CpsChoixSituationComponent,
    EdcChoixActiviteComponent,
    CvChoixbenefComponent,
    ChoixPatientDegradeComponent,
    CalculImcComponent,
    AnnuaireComponent,
    AddPaiementFactureComponent,
    ConfirmationChoixCustomComponent,
    AddFactureHandComponent,
    EditAdressePatientComponent,
    CompareImagesModalComponent,
    SelectDocumentModalComponent,
    AtcdSidePanelFragment,
    PresaisieMaquettefragment,
    ConfirmationSelectionMultipleCustomFragment,
    ModeleOrdonnancePanelFragment,
    EnregistrerModeleOrdonnanceFragment
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    PipesModule,
    ReactiveFormsModule,
    NgSelectModule,
    DragDropModule,
    MatMenuModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatDividerModule,
    InputMaskModule,
    MatTreeModule,
    MatIconModule,
    GoogleChartsModule,
    QuillModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatCardModule,
    DirectivesModule,
    ZXingScannerModule,
    MatSelectModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatRadioModule,
    MatDialogModule,
    MatListModule,
    MatButtonModule,
    MatInputModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatTabsModule,
    MatChipsModule,
    MatButtonToggleModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    MatProgressSpinnerModule,
    MatOptionModule,
    MatExpansionModule,
  ],
  exports: [
    AddAlarmeComponent,
    InlineSvgFragment,
    CardsFragment,
    AgendaEventFragment,
    ButtonFragment,
    SearchInputFragment,
    FormInputFragment,
    TableFragment,
    SideMenuFragment,
    SideMenuContainerFragment,
    LoadingModalFragment,
    TableRadioButtonFragment,
    AlertMessageFragment,
    InsQualificationFragment,
    CardNoScrollFragment,
    MemoFragment,
    AddPatientFragment,
    ChipFragment,
    HeaderFragment,
    HistoProfessionFragment,
    HistoContactFragment,
    HistoRepertoireFragment,
    ParentPatientFragment,
    AideSaisieFragment,
    ListAddDocumentsComponent,
    ImportDocumentsComponent,
    SaisieGuideeFragment,
    SearchCritereFragment,
    ConsultDataFragment,
    EditCourrierFragment,
    AddCorrespondantCourrier,
    AddCorrespondantInEditorComponent,
    SelectConsultationFragment,
    AddCourrierPersoFragment,
    DmpComponent,
    RechercheBddMedFragment,
    EditOrdonnanceFragment,
    FicheSamFragment,
    DocumentFormComponent,
    ProgressFragment,
    CreatePatientExistsFragment,
    QuickSendMSSFragment,
    InfoCorrespondantFragment,
    ComparePatientInfosComponent,
    SearchMedNomFragment,
    DatamatrixReaderComponent,
    CalculImcComponent,
    AnnuaireComponent,
    CompareImagesModalComponent,
    AtcdSidePanelFragment,
    PresaisieMaquettefragment,
    ConfirmationSelectionMultipleCustomFragment,
    ModeleOrdonnancePanelFragment,
    EnregistrerModeleOrdonnanceFragment
  ],
  providers: [
    InlineSvgFragment,
    Document,
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MOMENT_FORMATS }
  ]
})
export class FragmentsModule { }
